/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoVehicleBaseResponse as ModelsV4VehicleDtoVehicleBaseResponse } from '../../models/Models/v4/Vehicle/dto-vehicle-base-response';

export interface V4ApplicationsVehicleGet$Xml$Params {
  StockNo: number;
  DealerCode?: string;
}

export function v4ApplicationsVehicleGet$Xml(http: HttpClient, rootUrl: string, params: V4ApplicationsVehicleGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4ApplicationsVehicleGet$Xml.PATH, 'get');
  if (params) {
    rb.query('StockNo', params.StockNo, {});
    rb.query('DealerCode', params.DealerCode, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4VehicleDtoVehicleBaseResponse>;
    })
  );
}

v4ApplicationsVehicleGet$Xml.PATH = '/v4/applications/vehicle';
